import { Box, Typography } from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import Filters from './Filters';

const searchText = {
  pt: '8px',
  fontWeight: '400',
  fontSize: '14px',
  fontStyle: 'Inner',
  lineHeight: '20px',
  color: '#667085',
};
const container = {
  display: 'flex',
  mt: '10px',
  // border: '1px solid #000000',
    // marginLeft: "30px",
};

const SearchIconWrapper = styled('div')(() => ({
  height: '100%',
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'start-with',
  padding: '8px',
}));

const FilterBox = ({
  active,
  setActive,
  name,
  setName,
  handleSelectName,
  code,
  setCode,
  handleSelectCode,
  npiCode,
  setNpiCode,
  handleSelectNpiCode,
  onFilterSubmit,
  fileCategory,
}) => {
  const handleOpenProviderSearch = () => {
    setActive(!active);
  };

  return (
    <>
      <Box sx={container}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Box sx={{ position: 'absolute' }}>
            <Box
              onClick={handleOpenProviderSearch}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                bgcolor: '#ffffff',
                width: '100%',
                minWidth: '487px',
                m: 1,
                height: 40,
                borderRadius: '4px',
                border: '1px solid #D0D0D0',
              }}>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <Typography sx={searchText}>
                Search by name, code or NPI
              </Typography>
            </Box>
          </Box>

          {active && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                mt: '0px',
              }}>
              <Filters
                active={active}
                setActive={setActive}
                name={name}
                setName={setName}
                handleSelectName={handleSelectName}
                code={code}
                setCode={setCode}
                handleSelectCode={handleSelectCode}
                npiCode={npiCode}
                setNpiCode={setNpiCode}
                handleSelectNpiCode={handleSelectNpiCode}
                onFilterSubmit={onFilterSubmit}
                fileCategory={fileCategory}
              />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default FilterBox;
